

import { PublicClientApplication } from "@azure/msal-browser";
import { MSCLIENT_ID, REDIRECTURL, TENANT_ID } from "./config";

export const msalConfig = {
  auth: {
    clientId: MSCLIENT_ID,
    authority: "https://login.microsoftonline.com/" + TENANT_ID ,
    //  authority: "https://login.microsoftonline.com/common",
    redirectUri: REDIRECTURL,
  }
};



export const msalInstance = new PublicClientApplication(msalConfig);
